import gql from 'graphql-tag';

import { executeGqlMutation, type GqlMutationOptions } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendMutationStatsFactsAndQuotesForBlogBuilderArgs,
  BackendStatsFactsAndQuotesResponse,
} from 'src/types/backend';

import { FRAGMENT_STATS_FACTS_AND_QUOTES_REQUEST } from './schema';

const MUTATION = gql`
  mutation StatsFactsAndQuotesForBlogBuilder(
    $projectId: ID!
    $type: String!
    $cursor: String
    $documentId: ID
    $url: String
  ) {
    statsFactsAndQuotesForBlogBuilder(
      projectId: $projectId
      type: $type
      cursor: $cursor
      documentId: $documentId
      url: $url
    ) {
      cursor
      statsFactsAndQuotes {
        ...StatsFactsAndQuotesFields
      }
    }
  }
  ${FRAGMENT_STATS_FACTS_AND_QUOTES_REQUEST}
`;

type Variables = BackendMutationStatsFactsAndQuotesForBlogBuilderArgs;
type Result = BackendStatsFactsAndQuotesResponse;

export const statsFactsAndQuotesForBlogBuilder = async (
  variables: Variables,
  options?: Pick<GqlMutationOptions, 'abortSignal'>
): Promise<Result | undefined> => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
    options: {
      abortSignal: options?.abortSignal,
    },
  });

  return getSingleProp<Result>(result.data);
};
